import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import { History } from "history";
import React from "react";
import { UserMenuOptions } from "./models";
import { UserMenuItem } from "./UserMenuItem";

interface UserMenuProps {
  options?: UserMenuOptions;
  userSignedIn?: boolean;
  userFullName?: string;
  history: History;
  className?: string;
  onSignOutRequest: () => void;
}

interface UserMenuState {
  anchorEl?: any;
}

export const UserMenu = class extends React.Component<UserMenuProps, UserMenuState> {
  constructor(props: UserMenuProps) {
    super(props);

    this.state = {};
  }

  public render() {
    const { options, userSignedIn, userFullName, className, onSignOutRequest } = this.props;
    const items = options ? options.items : undefined;
    const showSignIn = options ? options.showSignIn : undefined;
    const showSignOut = options ? options.showSignOut : undefined;
    const { anchorEl } = this.state;

    const menuOpen = !!anchorEl;

    const menuItems = items
      ? items.map((item, index) => (
          <UserMenuItem key={`user-menu-item-${index}`} schema={item} onMenuItemClick={this.handleUserMenuClose} />
        ))
      : [];

    // If the User is currently signed in and we are to show a 'Sign out' menu item, wire-up the Sign-out handler...
    if (userSignedIn && showSignOut) {
      menuItems.push(
        <MenuItem key="user-menu-item-sign-out" onClick={onSignOutRequest}>
          Sign out
        </MenuItem>,
      );
    }

    return !userSignedIn ? (
      showSignIn ? (
        <Button onClick={this.handleSignInClick} variant="text" color="inherit" className={className}>
          Sign in
        </Button>
      ) : null
    ) : menuItems.length ? (
      <>
        <Button
          aria-owns={menuOpen ? "username-menu" : undefined}
          aria-haspopup="true"
          onClick={this.handleUserMenuClick}
          variant="text"
          color="inherit"
          className={className}
        >
          {userFullName}
        </Button>
        <Menu id="username-menu" anchorEl={anchorEl} open={menuOpen} onClose={this.handleUserMenuClose}>
          {menuItems}
        </Menu>
      </>
    ) : (
      <Typography className={className}>{userFullName}</Typography>
    );
  }

  public handleUserMenuClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    this.setState({ ...this.state, anchorEl: event.currentTarget });
  };

  public handleUserMenuClose = () => {
    this.setState({ ...this.state, anchorEl: null });
  };

  public handleSignInClick = () => {
    const { history } = this.props;

    history.push("/auth/signin");
  };
};
